/**
 * ScheduleTab Component
 * Program schedule information
 */

import React from 'react';
import styles from './TabStyles.module.css';

const ScheduleTab = ({ program }) => {
  const schedule = program?.schedule;
  const frequency = schedule?.frequency || [];

  return (
    <div className={styles.tabContainer}>
      <section className={styles.section}>
        <h3 className={styles.sectionTitle}>Schedule</h3>
        
        {/* Duration */}
        <div className={styles.scheduleInfo}>
          <p className={styles.scheduleDuration}>
            <strong>Program Duration:</strong>{' '}
            {schedule?.startDate 
              ? new Date(schedule.startDate).toLocaleDateString() 
              : 'N/A'}{' '}
            -{' '}
            {schedule?.endDate 
              ? new Date(schedule.endDate).toLocaleDateString() 
              : 'N/A'}
          </p>
        </div>

        {/* Session Times */}
        <div className={styles.frequencyList}>
          {frequency.length > 0 ? (
            frequency.map((session, index) => (
              <div key={index} className={styles.frequencyItem}>
                <span className={styles.sessionDay}>{session.day}</span>
                <span className={styles.sessionTime}>
                  {session.startTime} - {session.endTime}
                </span>
              </div>
            ))
          ) : (
            <p className={styles.emptyMessage}>No schedule information available.</p>
          )}
        </div>
      </section>
    </div>
  );
};

export default ScheduleTab;










